import { render, staticRenderFns } from "./ApplicationsItemEdit.vue?vue&type=template&id=0365f392&"
import script from "./ApplicationsItemEdit.vue?vue&type=script&lang=js&"
export * from "./ApplicationsItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports